import { FormControlLabel, Radio, TextField } from "@material-ui/core";
import React, { useState } from "react";
import styled from "styled-components";
import CustomDatePicker from "../custom.date.picker";

export default function SpecialRadioButton({
  value,
  onChange,
  currentRadioValue,
  type = "text",
  error,
  maxDecimals,
  disabled = false
}) {
  let [dynamicValue, setDynamicValue] = useState(value);

  const limitDecimalPlaces = (inputValue, maxDecimals) => {
    if (!maxDecimals || !inputValue || inputValue === '') return inputValue;
    
    const stringValue = String(inputValue);
    
    if (type === "number" && stringValue.includes('.')) {
      const [wholePart, decimalPart] = stringValue.split('.');
      
      if (decimalPart && decimalPart.length > maxDecimals) {
        return `${wholePart}.${decimalPart.substring(0, maxDecimals)}`;
      }
    }
    
    return inputValue;
  };

  const handleKeyPress = (e) => {
    if (type !== "number") return;

    const currentValue = e.target.value;
    const char = e.key;
    
    if (e.ctrlKey || e.metaKey || ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(char)) {
      return;
    }
    
    if (!maxDecimals || maxDecimals === 0) {
      if (char === '.') {
        e.preventDefault();
        return;
      }
      
      if (!/\d/.test(char)) {
        e.preventDefault();
        return;
      }
    } else {
      if (char === '.') {
        if (currentValue.includes('.')) {
          e.preventDefault();
        }
        return;
      }
      
      if (!/\d/.test(char)) {
        e.preventDefault();
        return;
      }
      
      if (currentValue.includes('.')) {
        const decimalPart = currentValue.split('.')[1];
        if (decimalPart && decimalPart.length >= maxDecimals) {
          e.preventDefault();
        }
      }
    }
  };

  return (
    <Container>
      <FormControlLabel
        value={currentRadioValue}
        control={<Radio color="primary" />}
      />
      {type === "date" ? (
        <CustomDatePicker
          label="Date"
          onChange={(value) => {
            onChange(value.getTime());
            setDynamicValue(value.getTime());
          }}
          showYearDropdown
          showMonthDropdown
          useShortMonthInDropdown
          error={error}
          dateFormat={"dd/MMM/yyyy"}
          disabled={disabled} // Add this
        />
      ) : (
        <TextField
          type={type}
          style={{ width: "5rem" }}
          variant="outlined"
          value={dynamicValue}
          disabled={disabled} // Add this
          inputProps={{
            step: type === "number" && maxDecimals && maxDecimals > 0 ? "0.01" : type === "number" ? "1" : undefined,
          }}
          onKeyPress={handleKeyPress}
          onChange={(e) => {
            const inputValue = e.target.value;
            const limitedValue = limitDecimalPlaces(inputValue, maxDecimals);
            
            onChange(limitedValue);
            setDynamicValue(limitedValue);
          }}
          onBlur={(e) => {
            if (type === "number" && e.target.value) {
              const numValue = parseFloat(e.target.value);
              if (!isNaN(numValue)) {
                let formattedValue;
                if (!maxDecimals || maxDecimals === 0) {
                  formattedValue = Math.round(numValue);
                } else {
                  formattedValue = parseFloat(numValue.toFixed(maxDecimals));
                }
                onChange(formattedValue);
                setDynamicValue(formattedValue);
              }
            }
          }}
          error={error}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
`;